import { ToastLevel } from '@src/common/components/ToastLevel';
import { DEFAULT_TOAST_DELAY } from '@src/common/context/ToastProvider';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

export const useToast = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showToast = useCallback(
    ({
      severity,
      title,
      message,
      closesAutomatically = true,
    }: {
      severity: ToastLevel;
      title?: string;
      message: string | React.ReactNode;
      closesAutomatically?: boolean;
    }) => {
      enqueueSnackbar(message, {
        variant: 'toast',
        severity,
        title,
        message,
        autoHideDuration: closesAutomatically ? DEFAULT_TOAST_DELAY : null,
      });
    },
    [enqueueSnackbar],
  );

  const showSuccessToast = (message: string) => {
    showToast({
      severity: ToastLevel.success,
      message,
    });
  };

  const showErrorToast = (message: string) => {
    showToast({
      severity: ToastLevel.error,
      message,
    });
  };

  const showWarningToast = (message: string) => {
    showToast({
      severity: ToastLevel.warning,
      message,
    });
  };

  return { showToast, showErrorToast, showSuccessToast, showWarningToast };
};
